// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","fieldset":"_1dHxmHG","fadeIn":"_2hOXZk8","cancel":"_3SFGnfL","button":"_1OeL99U"};